import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Endhand } from "../../common/game/GameControl";
import { endHand } from "../../slice/gameStateSlice";
import DcDialog from "../Dialogs/DcDialog";

const EndHandButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const handleEndHandClick = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const handleConfirmEndHand = useCallback(() => {
    setIsDialogOpen(false);
    Endhand(user.Id, gameState.GameCode, currentIndex, () => {
      dispatch(endHand(currentIndex));
    });
  }, [user.Id, gameState.GameCode, currentIndex, dispatch]);

  const handleCancelEndHand = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  if (gameState.DealerId === user.Id)
    return (
      <>
        {!isDialogOpen && (
          <button className="btn BtnSettle me-2 mt-2" onClick={handleEndHandClick}>
            End hand
          </button>
        )}
        <DcDialog
          isOpen={isDialogOpen}
          title="End hand?"
          body="Are you sure you want to end the current hand?"
          confirmLabel="End hand"
          cancelLabel="Cancel"
          variant="danger"
          onConfirm={handleConfirmEndHand}
          onCancel={handleCancelEndHand}
        />
      </>
    );
  else return <></>;
};

export default EndHandButton;
